<template>
  <div id="sections-defences-armor-class-details-fifth-edition">
    <div class="content" v-show="toggleState" style="clear:left;">
      <h4 class="header-bar">Armor Details</h4>
      <div class="row">
        <div class="col-7">
          <under-input v-model.trim="armorClass.armor.description">
            Armor
          </under-input>
        </div>
        <div class="col text-center">
          <proficiency v-model="armorClass.armor.proficiency">Proficiency</proficiency>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <under-input v-model.number="armorClass.armor.bonus" maxlength="2">
            AC
          </under-input>
        </div>
        <div class="col text-center">
          <under-input v-model.number="armorClass.armor.touchBonus" maxlength="2">
            TAC
          </under-input>
        </div>
        <div class="col text-center">
          <under-input v-model.number="armorClass.armor.maxDex" maxlength="2">
            Max Dex
          </under-input>
        </div>
        <div class="col-3 text-center">
          <under-input v-model.number="armorClass.armor.checkPenalty" maxlength="2">
            Penalty
          </under-input>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <under-input v-model.trim="armorClass.shield.description">
            Shield
          </under-input>
        </div>
        <div class="col-2 text-center">
          <under-input v-model.number="armorClass.shield.bonus" maxlength="2">
            AC
          </under-input>
        </div>
        <div class="col-2 text-center">
          <under-input v-model.number="armorClass.shield.touchBonus" maxlength="2">
            TAC
          </under-input>
        </div>
        <div class="col-3 text-center">
          <under-input v-model.number="armorClass.shield.checkPenalty" maxlength="2">
            Penalty
          </under-input>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { mapState } from "vuex";
import Proficiency from "../../shared/_Proficiency.vue";
import UnderCheckbox from "../../shared/_UnderCheckbox.vue";
import UnderInput from "../../shared/_UnderInput.vue";

export default {
  name: "sections-defenses-details-pfrpg2",
  components: {
    Proficiency,
    UnderCheckbox,
    UnderInput
  },
  props: ["toggleState"],
  computed: mapState({
    armorClass: state => state.characters.current.defense.armorClass
  })
};
</script>
